/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gift_Cta_H2Inputs */

const es_gift_cta_h2 = /** @type {(inputs: Gift_Cta_H2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El destinatario elige cuándo zarpar.`)
};

const gl_gift_cta_h2 = /** @type {(inputs: Gift_Cta_H2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O destinatario elixe cando zarpar.`)
};

const en_gift_cta_h2 = /** @type {(inputs: Gift_Cta_H2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`They choose when to sail.`)
};

/**
* | output |
* | --- |
* | "They choose when to sail." |
*
* @param {Gift_Cta_H2Inputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const gift_cta_h2 = /** @type {((inputs?: Gift_Cta_H2Inputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gift_Cta_H2Inputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_gift_cta_h2(inputs)
	if (locale === "en") return en_gift_cta_h2(inputs)
	return es_gift_cta_h2(inputs)
});